export const WEB_METHODS = Object.freeze({
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE'
})

export const MIME_TYPE = Object.freeze({
  IMAGE: 'IMAGE',
  TEXT: 'TEXT',
  AUDIO: 'AUDIO',
  VIDEO: 'VIDEO',
  APPLICATION: 'APPLICATION'
})
